import { render, staticRenderFns } from "./VistaCaritasNoticias.vue?vue&type=template&id=3835aba6"
import script from "./VistaCaritasNoticias.vue?vue&type=script&lang=js"
export * from "./VistaCaritasNoticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports